import React, { useEffect } from 'react';
import './marquee.css'; 

const CryptoMarquee = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      "symbols": [
        { "description": "BITCOIN", "proName": "BINANCE:BTCUSDT" },
        { "description": "ETHEREUM", "proName": "BINANCE:ETHUSDT" },
        { "description": "SOLANA", "proName": "BINANCE:SOLUSDT" },
        { "description": "MATIC", "proName": "BINANCE:MATICUSDT" },
        { "description": "USDT", "proName": "CRYPTOCAP:USDT.D" },
        { "description": "POKADOT", "proName": "BINANCE:DOTUSDT" },
        { "description": "DOGE", "proName": "BINANCE:DOGEUSDT" },
        { "description": "CHAINLINK", "proName": "BINANCE:LINKUSDT" },
        { "description": "BINANCE COIN", "proName": "BINANCE:BNBUSDT" },
        { "description": "CARDANO", "proName": "BINANCE:ADAUSDT" },
        { "description": "BITCOIN CASH", "proName": "BINANCE:BCHUSD.P" }
      ],
      "showSymbolLogo": true,
      "isTransparent": true,
      "displayMode": "adaptive",
      "colorTheme": "dark",
      "locale": "en"
    });

    // Append script to the container element
    const container = document.querySelector('.tradingview-widget-container__widget');
    if (container) {
      container.appendChild(script);
    }

    // Cleanup script on component unmount
    return () => {
      if (container && container.contains(script)) {
        container.removeChild(script);
      }
    };
  }, []);

  return (
    <div className='tradingview-widget-container'>
      <div className='tradingview-widget-container__widget'></div>
      <div className='tradingview-widget-copyright'>
        {/* <a href='https://www.tradingview.com/' rel='noopener nofollow' target='_blank'>
          <span className='blue-text'>Track all markets on TradingView</span>
        </a> */}
      </div>
    </div>
  );
};

export default CryptoMarquee;
